export const getAlgosTableColumnToggleData = (state) =>
  state.algosListTableSettings.columnToggle.data;

export const getAlgosTableColumnToggleUpdateTime = (state) =>
  state.algosListTableSettings.columnToggle.updateTime;
